import { useOrganizations } from '@contexts/organizations-provider';
import { useHasPermission } from '@contexts/permissions-provider';
import { DocumentsHeader } from '@features/documents/components/documents-header/DocumentsHeader';
import { SubmittedDocumentsContent } from '@features/documents/components/submitted-documents-content/SubmittedDocumentsContent';
import * as React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import styles from './SubmittedDocumentsPage.module.css';

const SubmittedDocumentsPage = React.memo((): React.ReactElement => {
  const { selectedOrganization } = useOrganizations();
  const canSubmit = useHasPermission('CustomerTrainingDocuments_Add_Org');
  const canDownload = useHasPermission('SubmittedTrainingDocuments_Open_Org');
  const navigate = useNavigate();

  const organizationId = selectedOrganization?.id;

  const handleSubmitClick = React.useCallback((): void => {
    navigate('submit-documents');
  }, [navigate]);

  return (
    <div
      data-testid="submitted-documents-page"
      className={styles.submittedDocumentsPage}
    >
      <DocumentsHeader
        title="Submitted documents"
        showSubmitButton={canSubmit}
        onSubmitClick={handleSubmitClick}
      />
      {organizationId && (
        <SubmittedDocumentsContent
          organizationId={organizationId}
          canDownload={canDownload}
        />
      )}
      <Outlet />
    </div>
  );
});

SubmittedDocumentsPage.displayName = 'SubmittedDocumentsPage';

export { SubmittedDocumentsPage };
